import React from 'react';
import "../css/footer.css"

const Footer = () => {
  return (
    <footer>
      <div className="copyright">
        <small>© 2025 株式会社 妙香 All rights reserved.</small>
      </div>
      <div className="voicevox">
        <p>
          <a href="https://voicevox.hiroshiba.jp/" target="_blank" rel="noopener noreferrer">
            VOICEVOX
          </a>
          使用
        </p>
      </div>
    </footer>
  );
};

export default Footer;
